jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
	brands: {
		forBrands: function (brands) {
			if ($j('#domPageVars').length > 0) {
				return brands.some(function (currentBrand) {
					return $j('#domPageVars').data('brandId') === currentBrand;
				});
			} else {
				// race condition, da unser JS async geladen wird. machmal ist das JS wohl früher fertig, als die Variable im DOM aufgebaut wurde
				window.setTimeout(function () {
					return brands.some(function (currentBrand) {
						return $j('#domPageVars').data('brandId') === currentBrand;
					});
				}, 1000);
			}
		},
	},
});
